import React, { createContext, useState } from 'react';

export const OnboardingCallModalContext = createContext({
  show_modal: false,
  closeModal: () => {},
  openModal: () => {}
});

export const OnboardingCallModalProvider = ({ children }) => {
  const [show_modal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  return (
    <OnboardingCallModalContext.Provider value={{ show_modal, closeModal, openModal }}>
      {children}
    </OnboardingCallModalContext.Provider>
  );
};
